module.exports = __webpack_public_path__ + "img/fit_pro.36f18058.webp";